export const indexHero = {
	title: 'Digitization in <br> construction',
	learnMore: 'Learn more',
	weAreMembers: 'We are members of',
};
